import { IconButton } from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { icons } from "../../../../stack/environment/icons/iconExport";

const CopyLinkButton = ({ controlId = null, remediationId = null }) => {
  const { trackEvent } = useAPI();
  const colors = useColors();
  const defaultTooltipTitle = "Copy link";
  const [tooltipTitle, setTooltipTitle] = useState(defaultTooltipTitle);

  const handleCopyLink = () => {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl).then(() => {
      setTooltipTitle("Link copied!");
      setTimeout(() => {
        setTooltipTitle(defaultTooltipTitle);
      }, 1500);

      const itemType = remediationId ? "Remediation" : "Control";
      const itemId = remediationId || controlId;
      trackEvent(`User copied ${itemType} link to clipboard - ${itemId}`);
    });
  };

  return (
    <CustomToolTip title={tooltipTitle} placement="top">
      <IconButton
        onClick={handleCopyLink}
        sx={{
          height: "32px",
          width: "32px",
          padding: "4px",
          borderRadius: "8px",
          border: `1px solid ${colors.enabled_stroke}`,
          backgroundColor: colors.common_white,
          "&:hover": {
            backgroundColor: colors.grey_8percent,
          },
        }}
      >
        <SvgToIcon IconLogo={icons.LinkIcon} width="18px" />
      </IconButton>
    </CustomToolTip>
  );
};

export default CopyLinkButton;
